import { render, staticRenderFns } from "./ExpartiateDescription.vue?vue&type=template&id=f695b82c&scoped=true"
import script from "./ExpartiateDescription.vue?vue&type=script&lang=js"
export * from "./ExpartiateDescription.vue?vue&type=script&lang=js"
import style0 from "./ExpartiateDescription.vue?vue&type=style&index=0&id=f695b82c&prod&lang=scss"
import style1 from "./ExpartiateDescription.vue?vue&type=style&index=1&id=f695b82c&prod&scoped=true&lang=scss"
import style2 from "./ExpartiateDescription.vue?vue&type=style&index=2&id=f695b82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f695b82c",
  null
  
)

export default component.exports